import "../ccn.scss";

const CcnTheme = () => <></>;
export default CcnTheme;
